import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";

class MyNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGetStartedButton: false,
      isDropdownVisible: false,
      isServicesDropdownVisible: false,
    };
  }

  componentDidMount() {
    this.setState({
      showGetStartedButton: this.shouldShowGetStartedButton(),
    });
  }

  shouldShowGetStartedButton = () => {
    const today = new Date();
    const targetDate = new Date("2024-04-24");
    return today >= targetDate;
  };

  scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  toggleServicesDropdown = () => {
    this.setState((prevState) => ({
      isServicesDropdownVisible: !prevState.isServicesDropdownVisible,
    }));
  };

  render() {
    const {
      showGetStartedButton,
      isDropdownVisible,
      isServicesDropdownVisible,
    } = this.state;

    return (
      <Navbar
        className="navbar-container"
        collapseOnSelect
        expand="lg"
        bg="white"
        variant="light"
        // onToggle gives you the expanded state (true/false)
        onToggle={(expanded) => this.setState({ isDropdownVisible: expanded })}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" style={{ color: "#3E826D" }}>
            <div className="navbar-item">
              <div className="logo" />
              <div className="logo-text">
                <Link to="/" style={{ color: "#3E826D" }}>
                  E&S Solutions
                </Link>
              </div>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" />

          <Navbar.Collapse
            id="main-navbar"
            style={
              this.state.isDropdownVisible
                ? {
                    backgroundColor: "#ffffff",
                    padding: "20px",
                    borderRadius: "0 0 12px 12px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                    marginTop: "10px",
                  }
                : {}
            }
          >
            <Nav className="mx-auto gap-3 fw-semibold">
              {/* Home */}
              <Nav.Link as={Link} to="/" onClick={this.scrollToTop}>
                Home
              </Nav.Link>

              {/* PRODUCTS DROPDOWN */}
              <NavDropdown title="Products" id="products-dropdown">
                <NavDropdown.Header>
                  Reporting & Transparency
                </NavDropdown.Header>

                <NavDropdown.Item as={Link} to="/plateform">
                  DiscloseAI & STAR Platform
                </NavDropdown.Item>

                <NavDropdown.Header>For E&S Practitioners</NavDropdown.Header>

                <NavDropdown.Item as={Link} to="/esraproduct">
                  myESRA & privatESRA
                </NavDropdown.Item>

                <NavDropdown.Header>For Developers</NavDropdown.Header>

                <NavDropdown.Item as={Link} to="/enterprise-builds">
                  Enterprise Builds
                </NavDropdown.Item>

                <NavDropdown.Header>Research Lab</NavDropdown.Header>

                <NavDropdown.Item as={Link} to="/research-lab">
                  reviewESRA & SmartESIA
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/ml">
                  Advanced Analytics
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/smarteia">
                  SmartEIA
                </NavDropdown.Item>

                <NavDropdown.Item style={{color: '#6c757d', fontSize: '.975rem'}} as={Link} to="/notion">
                Digital ESG
                </NavDropdown.Item>
              </NavDropdown>

              {/* About */}
              <Nav.Link as={Link} to="/about-us" onClick={this.scrollToTop}>
                About
              </Nav.Link>

              <Nav.Link as={Link} to="/trainings" onClick={this.scrollToTop}>
                Training
              </Nav.Link>
            </Nav>

            {/* Right Side Button */}
            {showGetStartedButton && (
              <Nav>
                <Button
                  as={Link}
                  to={localStorage.isLoggedIn ? "/profile" : "/login"}
                  variant="success"
                  className="px-4 fw-semibold"
                  style={{
                    backgroundColor: "#3E826D",
                    border: "none",
                    color: "white",
                    borderRadius: "8px",
                  }}
                >
                  {localStorage.isLoggedIn ? "Profile" : "Login"}
                </Button>
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default MyNavbar;
